import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

export function getRatingTier(rating: number | null | undefined): string {
  if (rating === null || rating === undefined) return '';
  if (rating >= 85) return 'high';
  if (rating >= 70) return 'medium-high';
  if (rating >= 50) return 'medium';
  return 'low';
}

export function getLogEntryByUserId(movie: any, user_id: number): any {
  return movie.user_ratings?.find((r: any) => r['user_id'] === user_id);
}

export function getWatchlistDate(
  movie: any,
  user_id: number,
): string | undefined {
  return getLogEntryByUserId(movie, user_id)?.watchlist_date;
}

export function isWatchlisted(movie: any, user_id: number): boolean {
  return getLogEntryByUserId(movie, user_id)?.watchlisted === true;
}

export function getRating(movie: any, user_id: number): number | undefined {
  return getLogEntryByUserId(movie, user_id)?.rating;
}

export function getAgoDate(date: string | Date): string {
  return dayjs(date)
    .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
    .fromNow();
}

export function getDuration(durationInMinutes: number): string {
  const dur = dayjs.duration(durationInMinutes, 'minutes');
  const days = dur.days();
  const hours = dur.hours();
  const minutes = dur.minutes();
  let formattedDuration = '';

  if (days > 0) {
    formattedDuration += `${days}d `;
  }
  if (hours > 0) {
    formattedDuration += `${hours}h `;
  }
  if (minutes > 0) {
    formattedDuration += `${minutes}min`;
  }

  return formattedDuration;
}

export function addUserToLogInfo(info: any, user_data: any): void {
  info.user_id = user_data.id;
  info.username = user_data.username;
  info.display_name = user_data.display_name;
}

function updateMovieRatingEntry(
  movie: any,
  info: any,
  user_data: any,
  fieldsToUpdate: string[],
): any[] {
  let entry = getLogEntryByUserId(movie, info.user_id);

  if (!entry) {
    addUserToLogInfo(info, user_data);
    entry = info;
  }

  let ratingIndex = movie.user_ratings.indexOf(entry);
  let newRatings = [...movie.user_ratings];
  if (ratingIndex < 0) {
    newRatings = [...newRatings, entry];
    ratingIndex = newRatings.length - 1;
  }

  fieldsToUpdate.forEach((field) => {
    newRatings[ratingIndex][field] = info[field];
  });

  return newRatings;
}

export function setWatchlistDate(movie: any, info: any, user_data: any): any[] {
  return updateMovieRatingEntry(movie, info, user_data, [
    'watchlist_date',
    'watchlisted',
  ]);
}

export function setRatingInfo(movie: any, info: any, user_data: any): any[] {
  return updateMovieRatingEntry(movie, info, user_data, [
    'rating',
    'watchlisted',
  ]);
}
